<template>
  <div class="header">
    <div class="right">
      <el-button @click="checkStatus" size="mini" type="primary" plain>发票领购状态</el-button>
    </div>
    <!-- <invoice-type v-model:code="listQuery.fplxdm"></invoice-type>
    <el-button :loading="loading" type="primary" size="mini" @click="search">查询</el-button> -->

  </div>
  <div class="home">
    <el-table v-loading="loading" ref="singleTable" :data="tableData" highlight-current-row border @current-change="handleCurrentChange" style="width: 100%" :header-cell-style="{background:'#66b1ff',color:'#ffff'}" size="mini">
      <el-table-column type="selection" width="55" align="center"> </el-table-column>
      <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
      <!-- <el-table-column property="fpzl" label="发票种类" width="120" align="center"></el-table-column> -->
      <el-table-column property="fpzldm" label="发票种类代码" width="120" align="center"></el-table-column>
      <el-table-column property="fpzlmc" label="发票种类名称" align="center"> </el-table-column>
      <!-- <el-table-column property="fplxdm" label="发票类型" align="center"> </el-table-column> -->
      <el-table-column label="发票类型" width="160" align="center">
        <template v-slot="scope">
          <span>{{ $fplx(scope.row.fplxdm) }}</span>
        </template>
      </el-table-column>
      <el-table-column property="myfpxe" label="每月购票限额" width="120" align="center"></el-table-column>
      <el-table-column property="mcfpxe" label="每次购票限额" width="120" align="center"></el-table-column>
      <el-table-column property="zgcpl" label="最高持票量" align="center"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
       <template #default="scope">
         <el-button @click="apply(scope.row)" type="text" size="small">申请领购</el-button>
       </template>
      </el-table-column>
    </el-table>
  </div>

  <!-- 申领发票弹框 -->
  <el-dialog v-model="dialogFormVisible" title="申请领购" width="60%" :before-close="handleClose">
    <!-- 表单 -->
    <el-form ref="temp" size="mini" label-position="right" label-width="100px" :model="temp" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="发票类型代码">
            <el-input disabled size="mini" v-model="temp.fplxdm"></el-input>
          </el-form-item>
          <el-form-item label="发票种类代码">
            <el-input disabled size="mini" v-model="temp.fpzldm"></el-input>
          </el-form-item>
          <el-form-item label="证件类型">
            <el-input disabled size="mini" v-model="temp.zjlx"></el-input>
          </el-form-item>
          <el-form-item label="证件编号">
            <el-input disabled size="mini" v-model="temp.zjhm"></el-input>
          </el-form-item>
          <el-form-item label="经办人姓名">
            <el-input disabled size="mini" v-model="temp.jbrxm"></el-input>
          </el-form-item>
          <el-form-item prop="slsl" label="申领数量">
            <el-input size="mini" v-model="temp.slsl"></el-input>
          </el-form-item>
          <el-form-item prop="slsj" label="申领时间">
            <el-date-picker
              value-format="YYYY-MM-DD hh:mm:ss"
              v-model="temp.slsj"
              type="datetime"
              placeholder="申领时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="slsm" label="申领说明">
            <el-input size="mini" v-model="temp.slsm"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申领方式">
            <el-radio-group v-model="temp.slfs">
              <el-radio label="1">自行领取</el-radio>
              <el-radio label="2">快递配送</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="sjrxm" label="收件人姓名">
            <el-input size="mini" v-model="temp.sjrxm"></el-input>
          </el-form-item>
          <el-form-item prop="yb" label="邮编">
            <el-input size="mini" v-model="temp.yb"></el-input>
          </el-form-item>
          <el-form-item prop="sjrdz" label="收件人地址">
            <el-input size="mini" v-model="temp.sjrdz"></el-input>
          </el-form-item>
          <el-form-item prop="gddh" label="固定电话">
            <el-input size="mini" v-model="temp.gddh"></el-input>
          </el-form-item>
          <el-form-item prop="yddh" label="移动电话">
            <el-input size="mini" v-model="temp.yddh"></el-input>
          </el-form-item>
          <el-form-item prop="bz" label="备注">
            <el-input size="mini" v-model="temp.bz"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="applaySave">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import router from '@/router/index.js'
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { applyInvoiceInfo, applyInvoice } from "@/api/apply";
import { parseTime } from "@/utils";
export default {
  name: 'InvoiceApply',
  created () {
    
  },
  data(){
    return {
      loading: false,
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
      },
      tableData: [],
      dialogFormVisible: false,
      temp: {
        comId: this.$store.getters['user/comInfo'].id*1,
        fplxdm: "",
        fpzldm: "",
        slsl: "",
        slsj: "",
        zjlx: "",
        zjhm: "",
        jbrxm: "",
        slsm: "",
        slfs: "",
        sjrxm: "",
        yb: "",
        sjrdz: "",
        gddh: "",
        yddh: "",
        bz: "",
      },
      rules: {
        slsl: [{required: true,message: '申请数量不能为空',trigger: 'blur',},],
        slsj: [{required: true,message: '申领时间不能为空',trigger: 'blur',},],
        slsm: [{required: true,message: '申领说明不能为空',trigger: 'blur',},],
        sjrxm: [{required: true,message: '收件人姓名不能为空',trigger: 'blur',},],
        yb: [{required: true,message: '邮编不能为空',trigger: 'blur',},],
        sjrdz: [{required: true,message: '收件人地址不能为空',trigger: 'blur',},],
        gddh: [{required: true,message: '固定电话不能为空',trigger: 'blur',},],
        yddh: [{required: true,message: '移动电话不能为空',trigger: 'blur',},],
        bz: [{required: true,message: '备注不能为空',trigger: 'blur',},],
      }
    }
  },
  created () {
    this.getList()
  },
  methods:{
    applaySave(){
      this.$refs["temp"].validate((valid) => {
        if (valid) {
          applyInvoice(this.temp).then(res=>{
            if(res.data.msg == "success"){
              this.$qzfMessage("申请成功，请前往状态查询查询申请进度")
            }
          })
        } else {
          console.log('error submit!')
          return false
        }
      })
    },
    apply(row){
      this.temp = {}
      this.temp.comId = this.$store.getters['user/comInfo'].id*1
      this.temp.fplxdm = row.fplxdm
      this.temp.fpzldm = row.fpzldm
      this.temp.zjlx = row.zjlx
      this.temp.zjhm = row.zjhm
      this.temp.jbrxm = row.jbrxm
      this.temp.slfs = "1"
      // '{y}-{m}-{d} {h}:{i}:{s}'
      this.temp.slsj = parseTime(new Date(),'{y}-{m}-{d} {h}:{i}:{s}')
      this.dialogFormVisible = true
    },
    search(){
      if(this.listQuery.fplxdm == ""){
        this.$qzfMessage("请选择发票类型", 1)
        return
      }
    },
    //获取列表
    getList(){
      this.loading = true
      applyInvoiceInfo(this.listQuery).then(res=>{
        this.loading = false
        if(res.data.data.list){
          this.tableData = res.data.data.list
        }
      })
    },
    checkStatus(){
      router.push( "/apply/InvoiceApplyStatus");
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.header{
  .right{
    float: right;
    margin: 10px 12px 10px 10px;
  }
}
</style>